import { createAction } from 'redux-actions'
import * as types from './actionTypes'
import DriverService from './service'
import { IS_APPLICATION_LOADING, SHOW_USER_FEEDBACK } from '../../actions/types'
import { driversPagination } from '../../utils/constants'
import { fetchLoadsByParams } from '../Loads/actions'
import { fetchLoadById } from '../LoadsDetails/actions'

export const fetchDrivers = (filters, pagination) => (
  (dispatch) => {
    const payload = {
      orderColumn: 'name',
      orderDirection: 'ASC',
      page: 1,
      size: driversPagination,
      ...filters,
    }
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
    DriverService
      .fetchDrivers(payload)
      .then((result) => {
        if (payload.page === 1) {
          dispatch(createAction(types.CLEAR_DRIVERS)())
        }
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        return dispatch(createAction(types.FETCH_DRIVER)({ result, pagination }))
      })
      .catch((err) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        console.log(err)
      })
  }
)


export const rateDriver = (driverId, comment, rating, shippingHash, deliveryId, refreshLoads) => (
  (dispatch) => {
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
    DriverService
      .rateDriver(driverId, { comment, rating, shippingHash, deliveryId })
      .then(() => {
        if (refreshLoads) {
          dispatch(fetchLoadsByParams({ tab: 'review' }))
        } else {
          dispatch(fetchLoadById(shippingHash))
        }
        return dispatch(createAction(SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Frete avaliado.',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        }))
      })
      .catch((err) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        console.log(err)
      })
  }
)

export const fetchRecentDrivers = (shippingHash, deliveryId) => (
  (dispatch) => {
    const payload = {
      shippingHash,
      orderColumn: 'createDate',
      orderDirection: 'DESC',
      page: 1,
      size: 10,
      deliveryId,
    }
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
    DriverService
      .fetchDrivers(payload)
      .then((result) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        return dispatch(createAction(types.FETCH_RECENT_DRIVERS)(result))
      })
      .catch((err) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        console.log(err)
      })
  }
)

export const searchDriverByCpf = (cpf) => (
  (dispatch) => {
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
    return DriverService
      .searchDriverByCpf(cpf)
      .then((result) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        return result
      })
      .catch((err) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        throw err
      })
      .finally(() => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
      })
  }
)

const throwIfApiNotOk = (res) => {
  if (res.ok) return res
  const msg = res.data?.message || res.data?.error || res.problem
  throw new Error(typeof msg === 'string' ? msg : 'Falha na operação.')
}

export const updateDriverByDataCiot = (id, payload) => (
  (dispatch) => {
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
    return DriverService
      .updateDriverByDataCiot(id, payload)
      .then((res) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        return throwIfApiNotOk(res)
      })
      .catch((err) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        throw err
      })
      .finally(() => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
      })
  }
)
